// extracted by mini-css-extract-plugin
export default {"download-template":"GroupsTab_download-template__sPxYf","icon":"GroupsTab_icon__lcTPb"};